module.exports = __webpack_public_path__ + "img/upload.46255432.svg";